const TEAM_COLORS = [
  '#F9BB06',
  '#53B5FC',
  '#995AFF',
  '#F376D8',
  '#24BA84',
  '#4E6BEF',
  '#FF8D5C',
  '#B4B662',
  '#2DC2F1',
  '#8960BD',
];

/** Stable color for a team, by its index in the team list. */
export const findTeamColor = (index: number): string => {
  return TEAM_COLORS[index % TEAM_COLORS.length];
};
